jQuery.noConflict();

printAgendasEPublicacoes();
printNoticias();
printTabCadastro();

var APIURL;
var APIUPLOADSURL;
var APPURL;
var SITEURL;
var WEBCHATTOKEN;

jQuery.ajax({
  type: "GET",
  url: "/getEnvs.php",
  dataType: "json",
  async: false
}).done(function (data) {
  APIURL = data.APIURL;
  APIUPLOADSURL = data.APIUPLOADSURL;
  APPURL = data.APPURL;
  SITEURL = data.SITEURL;
}).fail(function (msg) {
  console.debug('Error:');
  console.debug(msg);
}).always(function () { });


jQuery(function ($) {
  $("a").each(function() {
    let query = '?identifier=' + Util.getIdentifier();
    if (localStorage.getItem('token')) {
      query += "&token=" + localStorage.getItem("token");
    }
    try {
      if(((new URL($(this).attr("href"))).host).indexOf((new URL(APPURL)).host) > -1) {
        $(this).attr("href", $(this).attr("href") + query);
      }
    }
    catch(e){}
  });

    if (Util.getIdentifier() === 'fiesc') {
      document.querySelector('#menu-externo .d-none').classList.remove('d-none');
      document.querySelector('.background-nav .navbar ul.nav.d-none').classList.remove('d-none');
    }
});

jQuery(function ($) {
  'use strict';
  // Close nav
  $("#btn-close-nav, .block-menu > ul > li:nth-child(5) > a").click(function () {
    $("#btn-open-nav").click();
  });

  // Transição do video
  var videoAtual = "v1"
  var intervaloExecucao = 50
  var tempoExecutado = 0
  var videoPausado = false
  var execucaoCancelada = false
  var tempoMaximoExecucao = 11000
  executar()

  removerVideos();

  function removerVideos() {
    $('#homeControleVideo4').length && $('#homeControleVideo4').remove();
    $('#homeControleVideo5').length && $('#homeControleVideo5').remove();
  }

  function obterProximoVideo() {
    switch (videoAtual) {
      case "v1":
        return 'v2'
      case "v2":
        return 'v3'
      case "v3":
        return 'v1'
      // case "v4":
      //   return 'v5'
      // case "v5":
      //   return 'v1'
    }
  }

  function executar() {
    if (videoPausado) {
      return;
    }

    if (tempoExecutado >= tempoMaximoExecucao) {
      pararVideo(videoAtual);
      videoAtual = obterProximoVideo();
      iniciarVideo(videoAtual);
      removerVideosBotoesAtivos();
      var botaoParaAtivar = obterBotaoVideoAtivo();
      $('#' + botaoParaAtivar).addClass("ativado");
    }

    configurarProximaExecucao()
  }

  function pararVideo(videoId) {
    var video = document.getElementById(videoId)
    if (video !== null && video !== undefined) {
      video.pause()
      video.currentTime = 0;
      $(`#${videoId}`).fadeOut(0);
    }
  }

  function iniciarVideo(videoId) {
    var video = document.getElementById(videoId);
    if (video !== null && video !== undefined) {
      video.play();
      $(`#${videoId}`).fadeIn(0);
    }
  }

  function configurarProximaExecucao() {
    if (tempoExecutado >= tempoMaximoExecucao) {
      tempoExecutado = 0
    }

    setTimeout(function () {
      if (execucaoCancelada) {
        execucaoCancelada = false;
        return;
      }

      calcularPorcentagem()

      tempoExecutado += intervaloExecucao
      executar()
    }, intervaloExecucao);
  }

  function calcularPorcentagem() {
    var video = document.getElementById(videoAtual);
    if (video !== null && video !== undefined) {
      var porcentagem = parseInt((video.currentTime * 100) / 11, 10);
      $("#homePorcentagemVideo").attr("class", 'home-loading-circle p' + porcentagem);
    }
  }

  function alterarVideo(video) {
    tempoExecutado = 0

    if (!videoPausado) {
      execucaoCancelada = true
    }

    videoPausado = false
    pararVideo(videoAtual)
    videoAtual = video
    iniciarVideo(videoAtual)
    $("#homeBotaoPausarVideo").removeClass("video-pausado")
    executar()
  }

  function obterBotaoVideoAtivo() {
    switch (videoAtual) {
      case "v1":
        return "homeControleVideo1";
      case "v2":
        return "homeControleVideo2";
      case "v3":
        return "homeControleVideo3";
      // case "v4":
      //   return "homeControleVideo4";
      // case "v5":
      //   return "homeControleVideo5";
    }
  }

  function removerVideosBotoesAtivos() {
    $("#homeControleVideo1").removeClass("ativado")
    $("#homeControleVideo2").removeClass("ativado")
    $("#homeControleVideo3").removeClass("ativado")
    // $("#homeControleVideo4").removeClass("ativado")
    // $("#homeControleVideo5").removeClass("ativado")
  }

  $("#homeBotaoPausarVideo").click(function () {
    var $botao = $("#homeBotaoPausarVideo")

    if (videoPausado) {
      document.getElementById((videoAtual)).play();
      $botao.removeClass("video-pausado")
      videoPausado = false
      executar()
    } else {
      document.getElementById((videoAtual)).pause();
      videoPausado = true
      $botao.addClass("video-pausado")
    }
  })

  $("#homeControleVideo1").click(function () {
    removerVideosBotoesAtivos()
    $("#homeControleVideo1").addClass("ativado")
    alterarVideo("v1")
  })

  $("#homeControleVideo2").click(function () {
    removerVideosBotoesAtivos()
    $("#homeControleVideo2").addClass("ativado")
    alterarVideo("v2")
  })

  $("#homeControleVideo3").click(function () {
    removerVideosBotoesAtivos()
    $("#homeControleVideo3").addClass("ativado")
    alterarVideo("v3")
  })

  // $("#homeControleVideo4").click(function () {
  //   removerVideosBotoesAtivos()
  //   $("#homeControleVideo4").addClass("ativado")
  //   alterarVideo("v4")
  // })

  // $("#homeControleVideo5").click(function () {
  //   removerVideosBotoesAtivos()
  //   $("#homeControleVideo5").addClass("ativado")
  //   alterarVideo("v5")
  // })

  $('div.parallax').each(function () {
    var $obj = $(this);

    $(window).scroll(function () {
      var yPos = -($(window).scrollTop() / $obj.data('speed'));

      var bgpos = '100% ' + yPos + 'px';

      $obj.css('background-position', bgpos);

    });
  });

});

jQuery(function ($) {
  var topIntenacionalizacao = false;

  $("#top-saiba-mais, #close-top-conteudo").click(function (e) {
    e.preventDefault();
    if (topIntenacionalizacao) {

      $("#topResumo").show();
      $("#menu-primario").show();
      $("#topConteudo").hide();
      $("#close-top-conteudo").hide();
      $("#homeControleVideosInternacionalizacao").attr("style", "");
      topIntenacionalizacao = false;
    } else {

      $("#topResumo").hide();
      $("#menu-primario").hide();
      $("#topConteudo").show();
      $("#close-top-conteudo").show();
      $("#homeControleVideosInternacionalizacao").attr("style", "visibility:hidden;");
      topIntenacionalizacao = true;
    }
  });

  //Avaliacao modals

  $(".open-avaliacao-modal").click(function (e) {
    $(".avaliacao-modal").hide("slow");
    var target = "#" + $(this).attr("data-target");
    $(target).show("slow");
    $('html, body').animate({
      scrollTop: $(this).parent().parent().parent().parent().offset().top
    }, 2000);
  });

  $(".btn-close-avaliacao-modal").click(function (e) {
    var target = "#" + $(this).attr("data-target");
    $(target).hide("slow");
  });


  // Function which adds the 'animated' class to any '.animatable' in view
  var doAnimations = function () {

    // Calc current offset and get all animatables
    var offset = $(window).scrollTop() + $(window).height(),
      $animatables = $('.animatable');

    // Unbind scroll handler if we have no animatables
    if ($animatables.length == 0) {
      $(window).off('scroll', doAnimations);
    }

    // Check all animatables and animate them if necessary
    $animatables.each(function (i) {
      var $animatable = $(this);
      if (($animatable.offset().top + $animatable.height() - 20) < offset) {
        $animatable.removeClass('animatable').addClass('animated');
      }
    });

  };

  // Hook doAnimations on scroll, and trigger a scroll
  $(window).on('scroll', doAnimations);
  $(window).trigger('scroll');

  jQuery.ajax({
    type: "GET",
    url: APIURL + "/noticias/documentos?sort[data]=desc&perPage=6&type=banner",
    headers: {
      "identifier": Util.getIdentifier()
    },
    dataType: "json",
    success: function (data) {
      var maxPosts = 6;

      for (var i = 0; i < maxPosts; i++) {
        var image = "";
        var title = "";
        var link = "";
        var id = "";
        var noticiaClass = "";

        image = APIUPLOADSURL + '/' + data.rows[i].file;
        title = data.rows[i].noticia.titulo;
        link = `${APPURL}/#/noticias/detalhe/${data.rows[i].noticia.id}?identifier=${Util.getIdentifier()}`;
        id = "#destaque-noticia-" + i;
        noticiaClass = " text-black-50 texto-noticia ";

        if (title != null && title.length > 70) {
          title = title.substring(0, 70) + "...";
        }

        $(id + " .card-img").attr('style', 'background: url(' + image + ');');

        var text = "<div class=\"col-10 mb-3\">\n" +
          "<a href='" + link + "' class='" + noticiaClass + "' >" +
          title +
          "</a>" +
          "            </div>\n" +
          "            <div class=\"col-2 btn-mais align-self-end text-right mb-2 pl-0\">\n" +
          "<a href='" + link + "'>" +
          "              <img class=\"img-fluid\" alt=\"btn-mais\"\n" +
          "                   src=\"/themes/portal/images/internacionalize/btn-mais.png\">\n" +
          "</a>" +
          "            </div>";

        $(id + " .target-text").html(text);

      }
    }
  });


  var $_GET = {};

  document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
    function decode(s) {
      return decodeURIComponent(s.split("+").join(" "));
    }

    $_GET[decode(arguments[1])] = decode(arguments[2]);
  });

  if ($_GET.id) {
    var id = parseInt($_GET.id);
    jQuery.ajax({
      type: "GET",
      url: APIURL + "/noticia/" + (id + 1),
      headers: {
        "identifier": Util.getIdentifier()
      },
      dataType: "json",
      success: function (data) {
        $("#titulo").html(data.titulo);
        $("#conteudo").html(data.conteudo);
        $("#anterior").attr("data-id", id - 1);
        $("#proximo").attr("data-id", id + 1);

        if ((id - 1) < 0) {
          $("#anterior").attr("disabled", true);
        }
      }
    });
  }

  $('.botao-noticias').click(function () {
    var id = $(this).attr("data-id");
    window.location.href = "/noticia?id=" + id;
  });

  $("#contact-message-solicite-um-orcamento-form").prepend("<h2>Solicite um Orçamento</h2>");

  $(".bt-abre-form").click(function () {
    $('.bt-abre-form').hide();
    $('.fundo-botao-solicite-orcamento').attr('hidden', 'hidden');
    $("#objetivo-orcamento, #contact-message-solicite-um-orcamento-form").show();
    $('html, body').animate({
      scrollTop: $('#contact-message-solicite-um-orcamento-form').offset().top
    }, 'slow');
    $('.bt-fecha-form').show();
  });

  $('.bt-fecha-form').click(function () {
    $("#objetivo-orcamento, #contact-message-solicite-um-orcamento-form").hide();
    $('.fundo-botao-solicite-orcamento').removeAttr('hidden');
    $('.bt-fecha-form').hide();
    $('.bt-abre-form, #fundo-botao-solicite').show();
  });

  // Eventos e missoes
  var $_GET = {};

  document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
    function decode(s) {
      return decodeURIComponent(s.split("+").join(" "));
    }

    $_GET[decode(arguments[1])] = decode(arguments[2]);
  });


});

function getLocale() {
  if (window.location.pathname.includes('/en')) {
    return 'en';
  }
  if (window.location.pathname.includes('/es')) {
    return 'es';
  }
  return 'pt';
}

function getApiUrl() {
  let urlsend = new URL(APIURL);
  const locale = getLocale();
  if (['en', 'es'].indexOf(locale) > -1) {
    urlsend.pathname = `${locale}${urlsend.pathname}`;
  }
  return urlsend.toString();
}

jQuery(function ($) {
  var open = false;
  $("#open-bottom-menu").click(function () {
    if (!open) {
      open = true;
      $("#menu-bottom").show("slow");
      $("#open-bottom-menu > i").removeClass("fa-angle-down");
      $("#open-bottom-menu > i").addClass("fa-angle-up");
      $("html, body").animate({ scrollTop: $("body").height() }, 1000);
    } else {
      open = false;
      $("#menu-bottom").hide("slow");
      $("#open-bottom-menu > i").removeClass("fa-angle-up");
      $("#open-bottom-menu > i").addClass("fa-angle-down");
    }
  });

  $(document).ready(function () {
    if ($('#empresa').val() === 'ES') {
      $('#input-pais').attr('hidden', false);
    } else {
      $('#input-pais').attr('hidden', true);
    }


    $('#empresa').change(function () {
      if ($('#empresa').val() == 'ES') {
        $('#input-pais').removeClass('desabilita-input');
        $('#input-pais').attr('hidden', false);
      } else {
        $("#numeroFiscal").val("");
        $("#pais").val("");
        $('#input-pais').addClass('desabilita-input');
        $('#input-pais').attr('hidden', true);
      }
    });

    setTimeout(function() {
      if (this.getLocale() === 'en') {
        for(var i =0; i < document.querySelectorAll('.language_en').length;i++) {
          document.querySelectorAll('.language_en')[i].classList.toggle("d-none");
        }
        return;
      }

      if (this.getLocale() === 'es') {
        for(var i =0; i < document.querySelectorAll('.language_es').length;i++) {
          document.querySelectorAll('.language_es')[i].classList.toggle("d-none");
        }
        return;
      }

      for(var i =0; i < document.querySelectorAll('.language_pt-br').length;i++) {
        document.querySelectorAll('.language_pt-br')[i].classList.toggle("d-none")
      }
    }, 100)
  });


  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 20) {
      $('#contatos').show();
      return;
    }
    $('#contatos').hide();
  });

  $(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() == $(document).height()) {
      $('#contatos').addClass('margin-contatos')
    }
  });

  $("#open-contatos").click(function () {
    $("#pop-contatos").show("slow");
    $(this).hide();
    $("#close-contatos").show();
  });

  $("#close-contatos").click(function () {
    $("#form-contatos").hide("slow");
    $("#pop-contatos").hide("slow");
    $(this).hide();
    $("#open-contatos").show();
  });

  $("#open-form").click(function () {
    $("#pop-contatos").hide("slow");
    $("#form-contatos").show("slow");
    $('#edit-field-selecione-o-assunto-contato').val("");
    $('#edit-field-selecione-o-assunto-').val("");
    $("#form-contatos").attr("style", "display: flex; flex-direction: column;")
  });

  $("#botao-login").click(function () {
    $('.form-top').hide();
    $('#logando').show();
  });

  $("#btn-esqueci-senha").click(function () {
    $('.form-top').hide();
	$('#campo-email').hide();
    $('#esqueci-senha').show();
  });

  $("#btn-cadastre-se").click(function () {
    $("#btn-problema-cadastro").hide();
    loadCadastro();
    $('.form-top').hide();
    $("#pre-cadastro").show();
    $('#pre-cadastro #m1').show();
  })

  $('input:radio[name="consulta"]').change(function () {
    if ($(this).val() == 1) {
      $('#pre-cadastro #m2').hide();
      $('#pre-cadastro #m1').show();
    } else if ($(this).val() == 2) {
      $('#pre-cadastro #m1').hide();
      $('#pre-cadastro #m2').show();
    }
  });

  $("#btn-open-nav").on("click", function (){
    $("html").attr('style', 'overflow-y:hidden');
    $("#navbarPrimary").attr('style', 'overflow-y: unset');
    if($(".navbar-collapse.show").length){
      $("html").attr('style', 'overflow-y:unset');
      $("#navbarPrimary").attr('style', 'overflow-y: hidden');
    }
  });
});

function loadCadastro() {
  jQuery(function ($) {
    var dataAtual = (new Date()).toISOString().split('T')[0];
    if (Grid.getSelectedFromGrid($("#ajax_empresa [name=evento]")) === null) {
      $.ajax({
        url: APIURL + '/eventos?dataFinal[after]=' + dataAtual + '&isActive=true&order[dataInicial]=asc',
        headers: {
          "identifier": Util.getIdentifier()
        },
        type: 'get',
        dataType: "json",
        success: function (data) {
          const getUrl = function (e) {
            return `<a href="${APPURL}/#/evento/${e.slug}?identifier=${Util.getIdentifier()}" class="text-dark text-decoration-none" target="_blank">${e.nomeEvento}</a>`;
          }
          let dataSource = [];
          $.each(data, function (i, d) {
            dataSource.push({
              id: d.id,
              nomeEvento: getUrl(d),
              dataInicial: (new Date(d.dataInicial)).toLocaleDateString(),
              dataFinal: (new Date(d.dataFinal)).toLocaleDateString()
            });
          });

          Grid.setGrid($("#ajax_empresa [name=evento]"), {
            values: {
              dataSource: dataSource,
              columns: [
                { field: 'nomeEvento', title: 'Evento' },
                { field: 'dataInicial', title: 'Data Inicial', width: 80 },
                { field: 'dataFinal', title: 'Data Final', width: 80 }
              ],
              pager: {
                limit: 6,
                startIndex: 0
              }
            }
          })
        }
      });
    }
    findConfiguration();
  });
}

//pre cadastro empresa
function verificaForcaSenha(cpSenha) {
  senha = cpSenha.val();
  var regex = /^(?=(?:.*?[A-Z]){1})(?=(?:.*?[0-9]){1})(?=(?:.*?[!@#$%*()_+^&}{:;?.]){1})(?!.*\s)[0-9a-zA-Z!@#$%;*(){}_+^&]*$/;
  if (senha.length < 6 || !regex.exec(senha)) {
    alert("A senha deverá conter no mínimo 6 caracteres.\n - mínimo 1 letra maiúscula;\n - mínimo 1 número;\n - mínimo 1 caracter especial.");
    cpSenha.focus();
    return false;
  }
  return true;
}

function isEmailFiesc(email) {
  return email.endsWith("@fiesc.com.br");
}

jQuery(function ($) {
  $('#empresa').change(function () {
    if ($(this).find(':selected').val() == 'ES') {
      $('#numeroFiscal, #pais').removeAttr('disabled');
    } else {
      $('#numeroFiscal, #pais').attr('visible', true);
    }
  });

  $('#ajax_empresa').submit(function (e) {
    e.preventDefault()
    if (!verificaForcaSenha($("#senha"))) {
      return false;
    }

    //valida se a senha é igual
    if ($("#senha").val() != $('#senha1').val()) {
      alert('Por favor, digite senhas iguais');
      return false;
    }

    //validar cnpj
    if (!Util.validarCNPJ($('#cnpj').val())) {
      alert('CNPJ INVALIDO');
      return false;
    }

    //validar se o email é fiesc
    if (isEmailFiesc($('#email').val())) {
      alert('E-mail inválido para cadastro de empresa');
      return false;
    }

    jQuery.ajax({
      data: {
        cnpj: $('#cnpj').val(),
        areaAtuacao: $('#areaAtuacao').find(':selected').val(),
        razaoSocial: $('#razaoSocial').val(),
        nomeFantasia: $('#nomeFantasia').val(),
        cep: $('#cep').val(),
        nacionalidade: $('#empresa').find(':selected').val(),
        numeroIdentificadorFiscal: $('#numeroFiscal').val(),
        pais: $('#pais').val(),
        produto: $('#produto').val(),
        telefoneComercial: $('#telcomercial').val(),
        email: $('#email').val(),
        password: $('#senha').val(),
        nomeCompleto: $('#nomecompleto').val(),
        newsletter: $('#newsletter').prop('checked'),
        eventoId: (Grid.getSelectedFromGrid($("#ajax_empresa [name=evento]"))?.id) ?? null
      },
      type: 'POST',
      url: APIURL + '/pre/cadastros',
      headers: {
        "identifier": Util.getIdentifier()
      },
      success: function (data) {
        var msg;
        if (data.primeira) {
          msg = 'Este é o primeiro cadastro deste CNPJ na plataforma, portanto o sistema irá considerar este login como administrador da empresa. Você terá acesso a todas as páginas que exigem login dentro da plataforma e gerenciamento de usuários da empresa. Como administrador, você será direcionado ao dashboard onde terá acesso a todos os arquivos referentes a sua empresa. ';
        } else {
          msg = 'Este CNPJ já possui cadastro na plataforma. Para ter acesso aos nossos serviços, entre em contato com o responsável administrador da sua empresa para que ele admita o seu cadastro. ';
        }
        alert(msg);
        $("#login-email").val(data.email);
        $("#login-senha").val($('#senha').val());
        $("#btn-close-nav").click();
        $("#frm-login").submit();
      },
      error: function (data) {
        var errorMensage = "";
        for (var i in data.responseJSON.errorMensages) {
          errorMensage = errorMensage + data.responseJSON.errorMensages[i] + "\n";
        }
        alert(errorMensage);
      }
    });
    return false;
  });
});

function ResetCampos() {
  var textFields = document.getElementsByTagName("input");
  for (var i = 0; i < textFields.length; i++) {
    if (textFields[i].type == "text") {
      textFields[i].style.backgroundColor = "";
      textFields[i].style.borderColor = "";
    }
  }
}

//pre cadastro fisico
jQuery(function ($) {
  $('#ajax_fisico').submit(function (e) {
    e.preventDefault()

    var senhaCadastro = $('#senhaCadastro');
    var senhaCadastro1 = $('#senhaCadastro1');

    if (!verificaForcaSenha(senhaCadastro)) {
      return false;
    }

    //valida se a senha é igual
    if (senhaCadastro.val() != senhaCadastro1.val()) {
      alert('Por favor, digite senhas iguais');
      return false;
    }

    jQuery.ajax({
      data: {
        "nomeCompleto": nomeCompleto.value,
        "email": emailCadastro.value,
        "password": senhaCadastro.val(),
      },
      type: 'POST',
      url: APIURL + '/cadastropessoafisica',
      headers: {
        "identifier": Util.getIdentifier()
      },
      success: function (data) {
        alert("Obrigado, " + data.nomeCompleto + ", agora você ja pode entrar em nossas áreas restritas.");
        $("#login-email").val(data.email);
        $('.form-top').hide();
        $('#logando').show();
      },
      error: function (data) {
        var errorMensage = "";
        for (var i in data.responseJSON.errorMesage) {
          errorMensage = errorMensage + data.responseJSON.errorMesage[i] + "\n";
        }
        alert(errorMensage);
      }

    });
    return true;

  });
});

//Estamos Logado

var storageCache = [];
var tokenParam = ''

function getQueryParams(qs) {
  qs = qs.split('+').join(' ');

  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

queryParams = getQueryParams(document.location.search);
var cadastroUrlParams = {
  cnpj: queryParams.cnpj || '',
  email: queryParams.email || '',
  nomeCompleto: queryParams.nomeCompleto || ''
};
if (queryParams.token) {
  tokenParam = '?token=' + queryParams.token;
}
jQuery(function ($) {
  if (queryParams.token != null) {
    tokenParam = "?token=" + queryParams.token;
  } else if (localStorage.getItem("token") != null) {
    tokenParam = "?token=" + localStorage.getItem("token");
  } else {
    tokenParam = null;
  }
  if (tokenParam != "" && tokenParam != null && !queryParams.precadastro) {
    $.ajax({
      url: APIURL + "/login/islogged" + tokenParam,
      headers: {
        "identifier": Util.getIdentifier()
      },
      type: "get",
      success: function (data) {
        findConfiguration();
        if (data.error == "notuser") {
          localStorage.clear();
          tokenParam = "";
          $("#username").html("");
          $("#notUserLogged").removeAttr('style', 'display:none');
          $("#userLogged").attr('style', 'display:none');
          $("#menu-geral-logged").hide();
          $("#menu-geral-nologged").show();
        } else {
          for (var i in data) {
            localStorage.setItem(i, data[i]);
          }
          tokenParam = "?token=" + localStorage.getItem("token");
          $("#username").html(localStorage.getItem("nomeCompleto").split(' ')[0]);
          $("#notUserLogged").attr('style', 'display:none');
          $("#userLogged").removeAttr('style', 'display:none');
          $("#userLogged #userName").html(localStorage.getItem("nomeCompleto").split(' ')[0]);
          $(".form-top").hide();
          $("#menu-geral-nologged").hide();
          $("#menu-geral-logged").show();
          mostraBotaoDash();
        }
      },
      error: function () {
        localStorage.clear();
        tokenParam = "";
        $("#username").html("");
        $("#notUserLogged").removeAttr('style', 'display:none');
        $("#userLogged").attr('style', 'display:none');
        $("#menu-geral-logged").hide();
        $("#menu-geral-nologged").show();
        tokenParam = "";
      },
    });
  } else {
    localStorage.clear();
    tokenParam = "";
    $("#username").html("");
    $("#notUserLogged").removeAttr('style', 'display:none');
    $("#userLogged").attr('style', 'display:none');
    $("#menu-geral-logged").hide();
    $("#menu-geral-nologged").show();
    tokenParam = "";
  }
  findConfiguration();
});

function findConfiguration() {
  const headers = {
    "identifier": Util.getIdentifier()
  }
  if (tokenParam && tokenParam.trim() !== '') {
    headers["Authorization"] = 'Bearer ' + tokenParam.slice(tokenParam.indexOf('=') + 1, tokenParam.length);
  }
  jQuery(($) => {
    $.ajax({
      url: APIURL + "/configurations",
      headers,
      type: "get",
      success: function (data) {
        printTabCadastro(data);
        printAgendasEPublicacoes(data);
        printNoticias(data);
        setFederationFooter(data);
        printNewsLetterLoginChkBox(data);
        showBannerNewsletter(data);
        if (data) {
          if(data.messaging_service == 1) {
            $(".messaging").html(`<a class="whatsapp" href="https://api.whatsapp.com/send?phone=${data.messaging_value}" target="_blank">
            <span class="fab fa-whatsapp"></span>
          </a>`);
          }
          if(data.messaging_service == 2) {
            $(".messaging").html(`<a class="telegram" href="https://t.me/${data.messaging_value}" target="_blank">
            <span class="fab fa-telegram"></span>
          </a>`);
          }
          if(data.messaging_service == 3) {
            var $temp = $("<div>").html(data.messaging_value);
            var $scriptTag = $temp.find("script");

            if($scriptTag.length) {
              var scriptId = $scriptTag.attr("id");
              var scriptSrc = $scriptTag.attr("src");

              // Só adiciona se ainda não existir na página
              if(scriptId && document.getElementById(scriptId)) return;
              if(scriptSrc && document.querySelector('script[src="' + scriptSrc + '"]')) return;

              var script = document.createElement("script");

              $.each($scriptTag[0].attributes, function() {
                script.setAttribute(this.name, this.value);
              });

              if($scriptTag.html()) {
                script.textContent = $scriptTag.html();
              }

              document.body.appendChild(script);
            }
          }

        }
      }
    });
  })
}

var URLTarget = null;
var URLPerms = null;
var actionTarget = false;

function showCadastro() {
  jQuery(function ($) {
    $("#btn-problema-cadastro").hide();
    loadCadastro();
    $('#div1').click();
    $('.form-top').hide();
    $('#pre-cadastro').show();
    $('#pre-cadastro #m1').show();
    $('#btn-open-nav').click();
    preencherCamposCadastro();
  });
}

function formatarCnpjCadastro(cnpj) {
  if (!cnpj) {
    return '';
  }
  var limpo = String(cnpj).replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  if (limpo.length !== 14) {
    return String(cnpj);
  }
  return limpo.substring(0, 2) + '.' +
    limpo.substring(2, 5) + '.' +
    limpo.substring(5, 8) + '/' +
    limpo.substring(8, 12) + '-' +
    limpo.substring(12, 14);
}

function getParametroCadastro(nome) {
  var valor = '';
  if (typeof cadastroUrlParams !== 'undefined' && cadastroUrlParams[nome]) {
    valor = cadastroUrlParams[nome];
  }
  if (!valor && typeof queryParams !== 'undefined' && queryParams[nome]) {
    valor = queryParams[nome];
  }
  return valor ? String(valor).trim() : '';
}

function preencherCamposCadastro(tentativa) {
  tentativa = tentativa || 0;
  jQuery(function ($) {
    function setCampo(seletor, valor) {
      if (!valor) {
        return false;
      }
      var $campo = $(seletor);
      if (!$campo.length) {
        return false;
      }
      if (!$campo.attr('placeholder')) {
        $campo.attr('placeholder', ' ');
      }
      $campo.val(valor).trigger('input').trigger('change').trigger('blur');
      return true;
    }

    var cnpj = getParametroCadastro('cnpj');
    var email = getParametroCadastro('email');
    var nomeCompleto = getParametroCadastro('nomeCompleto');

    if (!cnpj && !email && !nomeCompleto) {
      return;
    }

    if ($('#ajax_empresa #cnpj').length === 0) {
      if (tentativa < 10) {
        setTimeout(function () {
          preencherCamposCadastro(tentativa + 1);
        }, 200);
      }
      return;
    }

    setCampo('#ajax_empresa #cnpj', formatarCnpjCadastro(cnpj));
    setCampo('#ajax_empresa #email', email);
    setCampo('#ajax_empresa #nomecompleto', nomeCompleto);

    if (tentativa < 3) {
      setTimeout(function () {
        preencherCamposCadastro(tentativa + 1);
      }, 300);
    }
  });
}

function printNoticias(data = null) {
  jQuery(function($) {
    if (!data || !data.modules || data.modules.indexOf('noticias') < 0) {
      $('#noticias').hide();
    } else {
      $('#noticias').show();
    }
  });
}

function printTabCadastro(data = null) {
    if (!data || !data.modules || data.modules.indexOf('rodadasDeNegocios') < 0) {
      document.getElementById('tab-cadastro').style.setProperty('display', 'none', 'important');
    } else {
      document.getElementById('tab-cadastro').style.setProperty('display', '', 'important');
    }
}

function printNewsLetterLoginChkBox(data = null) {
  jQuery(function($) {
    if (!data || !data.modules || data.modules.indexOf('publicacoes') < 0 && data.modules.indexOf('eventosMissoesCapacitacoes') < 0) {
      $('#container-newsletter').hide();
    } else {
      $('#container-newsletter').show()
    }
  })
}

function printAgendasEPublicacoes(data = null) {
  jQuery(function($){
    const requiredModules = ['publicacoes', 'eventosMissoesCapacitacoes', 'capacitacoes', 'rodadasDeNegocios'];
    if (!data || !data.modules || !arrayContainsOneOfTheseValues(data.modules, requiredModules)) {
      $('#toolbox').hide();
      $('#agenda_pub').hide();
      requiredModules.forEach((x) => {
        $(`[name="${x}"]`).hide();
      });
    } else {
      $('#toolbox').show();
      $('#agenda_pub').show();

      requiredModules.forEach((x) => {
        if (arrayContainsOneOfTheseValues(data.modules, [x])) {
          $(`[name="${x}"]`).show();
        } else {
          $(`[name="${x}"]`).hide();
        }
      });
    }
  });
}

function setFederationFooter(data) {
    if (Util.getIdentifier() !== 'fiesc') {
      let check = false;
      let html = `
        <footer class="py-0">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-5 pt-2 pb-3 parte-cima">
                        <div class="row text-center w-100 pt-2">
                            `;

      if (data.social_media && data.social_media.institutional && data.federation_footer_logo) {
        check = true;
        html += `<div class="col-12">
                    <div class="pb-4 mx-auto">
                      <a href="${data.social_media.institutional}">
                        <img class="logo mt-3" style="width: 160px;"
                          src="${APIUPLOADSURL}/${data.federation_footer_logo}">
                      </a>
                    </div>
                </div>`;
      }

      if (data.address) {
        check = true;
        html += `<div class="col-12 icon-text px-0">
              <div class="w-100">
                <img alt="Ícone Endereço" height="50" src="/themes/portal/images/icon-rodape-dress.png" width="50">
                <span style="font-size: 0.8em">${data.address}</span>
              </div>
          </div>`;
      }

      if (data.contact && data.contact.email) {
        check = true;
        html += `<div class="col-12 icon-text px-0">
              <div class="w-100">
                <img alt="Ícone E-mail" height="50" src="/themes/portal/images/icon-rodape-mail.png" width="50">
                <span style="font-size: 0.8em">${data.contact.email}</span>
              </div>
          </div>`;
      }

      if (data.contact && data.contact.phone) {
        check = true;
        html += `<div class="col-12 icon-text px-0">
            <div class="w-100">
              <img alt="Ícone Telefone" height="50" src="/themes/portal/images/icon-rodape-phone.png" width="50">
                <span style="font-size: 0.8em">${Util.formatPhoneNumber(data.contact.phone.toString())}</span>
            </div>
          </div>`;
      }

      if (data.description) {
        check = true;
        html += `<div class="col-12 px-0 pt-4">
          <h2 style="font-size: 0.8rem;">${data.description}</h2>
        </div>`;
      }

      html += `</div>
          </div>
        <div class="col-12 d-flex pt-3 pb-5 px-4 justify-content-center">`;

        if (data.social_media) {
          check = true;
          if (data.social_media.facebook) {
            html += `<div>
              <a href="${data.social_media.facebook}" title="Facebook ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-facebook"></i>
              </a>
            </div>`;
          }

          if (data.social_media.twitter) {
            html += `<div>
              <a href="${data.social_media.twitter}" title="Twitter ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-twitter"></i>
              </a>
            </div>`;
          }

          if (data.social_media.instagram) {
            html += `<div>
              <a href="${data.social_media.instagram}" title="Instagram ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-instagram"></i>
              </a>
            </div>`;
          }

          if (data.social_media.linkedin) {
            html += `<div>
              <a href="${data.social_media.linkedin}" title="Linkedin ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-linkedin"></i>
              </a>
            </div>`;
          }

          if (data.social_media.youtube) {
            html += `<div>
              <a href="${data.social_media.youtube}" title="Youtube ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-youtube-play"></i>
              </a>
            </div>`;
          }

          if (data.social_media.sound_cloud) {
            html += `<div>
              <a href="${data.social_media.sound_cloud}" title="Sound Cloud ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-soundcloud"></i>
              </a>
            </div>`;
          }

          if (data.social_media.flickr) {
            html += `<div>
              <a href="${data.social_media.flickr}" title="flickr ${Util.getIdentifier()}" class="circulo"
                style="margin: 3px !important">
                <i class="fa fa-flickr"></i>
              </a>
            </div>`;
          }
        }

      html += `</div>
                </div>
            </div>
        </footer>`;
      if (check) {
        document.querySelector('nav#menu-externo').innerHTML = html;
      }
    }
}

function showBannerNewsletter(data) {
  if (data && data.modules && arrayContainsOneOfTheseValues(
      data.modules, ['publicacoes', 'eventosMissoesCapacitacoes'])) {
    document.querySelector('.background-nav #bannerNewsletter.d-none').classList.remove('d-none');
  }
}

function arrayContainsOneOfTheseValues(array, values) {
  for (element of values) {
    if (array.indexOf(element) > -1) {
      return true;
    }
  }
  return false;
}

function showLogin() {
  document.getElementById('botao-login').click();
  document.getElementById('btn-open-nav').click();
  URLTarget = null;
}

function showTrocarSenha() {
  jQuery(function ($) {
    $('.form-top').hide();
    $('#senha-atual').show();
    $("#btn-close-nav").click();
  })
}

if (queryParams.needLogin) {
  localStorage.clear();
  jQuery(function ($) {
    $(document).ready(function () {
      showLogin();
      URLTarget = queryParams.navigationOrigin + window.location.hash;
    })
  })
}
if (queryParams.precadastro) {
  jQuery(function ($) {
    showCadastro();
    if(queryParams.navigationOrigin){
      URLTarget = queryParams.navigationOrigin + window.location.hash;
      actionTarget = true;
    }
  })
}
if (queryParams.esquecisenha) {
  jQuery(function ($) {
    $('#btn-esqueci-senha').click();
    $('#btn-open-nav').click();
  })
}

if (queryParams.needLogout) {
  localStorage.clear();
}

setTimeout(function () {
  clearQueryParams();
}, (queryParams.precadastro && (cadastroUrlParams.cnpj || cadastroUrlParams.email || cadastroUrlParams.nomeCompleto)) ? 8000 : 3000);
constroiBreadcrumbNoticia();
constroiBreadcrumbParaOndeExportar();
constroiBreadcrumbDeOndeExportar();

document.body.onload = appendLoader;
function appendLoader(){
  var loader = document.createElement("div");
  loader.className = "loader";

  var loaderOverlay = document.createElement("div");
  loaderOverlay.className = "loader-overlay";
  loaderOverlay.appendChild(loader);

  var darkScreen = document.createElement("div");
  darkScreen.className = "dark-screen";

  var loaderComponent = document.createElement("div");
  loaderComponent.setAttribute('id', 'loader');
  loaderComponent.style = "display:none";
  loaderComponent.appendChild(darkScreen);
  loaderComponent.appendChild(loaderOverlay);

  document.body.prepend(loaderComponent);
}

function blockScreen(){
  document.querySelector('body #loader').style = "display:block;";
}

function unBlockScreen(){
  document.querySelector('body #loader').style = "display:none;";
}

document.addEventListener("click", function(event){
  if(!event.target.closest(".container-fluid.open")){
    if(document.querySelector('.container-fluid.open')){
      openCloseToolBox();
    }
  }
}, false);

function openCloseToolBox(info = null) {
  let toggle = false;
  if (info != null) {
    toggle = document.querySelector(".btn-open-toolbox").classList.contains("cursor-pointer");
  } else {
    toggle = document.querySelector(".btn-close-toolbox").classList.contains("cursor-pointer");
  }
  if (toggle) {
    // document.querySelector(".btn-open-toolbox").classList.toggle("cursor-pointer");
    document.querySelector("#toolbox").classList.toggle("open");
    document.querySelector("#plcht-container").classList.toggle("d-none");
    document.querySelector(".btn-close-toolbox").classList.toggle("d-none");
    document.querySelector("body").classList.toggle("no-scrollbar");
  }
}
var lastSelected = "publicacoes";
jQuery(function ($) {
  $(document).ready(function () {
    document.querySelector('#toolbox #newsletterInscricao')
        .href = `${APPURL}/#/noticias/inscrever-se?identifier=${Util.getIdentifier()}`;
    $(".events div, .btn-open-toolbox").click(function () {
      getSchedulePublication("eventoSeminario", "events");
    });
    $(".missions div").click(function () {
      getSchedulePublication("missao", "missions");
    });
    $(".training div").click(function () {
      getSchedulePublication("capacitacao", "training");
    });
    $(".publications div").click(function () {
      getSchedulePublication("publicacoes", "publications");
    });
    $(".rounds div").click(function () {
      getSchedulePublication("rodadaNegocio", "rounds");
    });
  });
});
function getSchedulePublication(type, className) {
  jQuery(function ($) {
    if (lastSelected != type) {
      var html = "";
      var url = "";
      if(type != "publicacoes"){
        var date = new Date();
        var afterYear = date.getFullYear();
        var afterMonth = date.getMonth() + 1;
        var afterDay = date.getDate();
        if (afterMonth.toString().length == 1) {
          afterMonth = "0" + afterMonth;
        }
        if (afterDay.toString().length == 1) {
          afterDay = "0" + afterDay;
        }
        var afterDate = `${afterYear}-${afterMonth}-${afterDay}`;
        date.setDate(date.getDate() + 30);
        var beforeYear = date.getFullYear();
        var beforeMonth = date.getMonth() + 1;
        var beforeDay = date.getDate();
        if (beforeMonth.toString().length == 1) {
          beforeMonth = "0" + beforeMonth;
        }
        if (beforeDay.toString().length == 1) {
          beforeDay = "0" + beforeDay;
        }
        var beforeDate = `${beforeYear}-${beforeMonth}-${beforeDay}`;
        var filterType = type;
        switch (filterType) {
          case "eventoSeminario":
            filterType = "evento"
          break;
        }
        url = `eventos/between/dates?startDate=${afterDate}&finishDate=${beforeDate}&tipo=${filterType}`;
      }
      else{
        url = "publicacao/all/orderby:dataPublicacao%20DESC|pageSize:20";
      }

      try {
        jQuery.ajax({
          type: "GET",
          url: APIURL + '/' + url,
          headers: {
            "identifier": Util.getIdentifier()
          },
          dataType: "json",
          success: function (data) {
            var urlTodos = "publicacoes";
            if (type != "publicacoes") {
              urlTodos = "eventos/";
              if(type == "missao"){
                urlTodos += "missao";
              }
              else if (type == "capacitacao"){
                urlTodos += "capacitacoes";
              }
              else if (type == "rodadaNegocio"){
                urlTodos += "rodadas-de-negocios";
              }
              else{
                urlTodos += "eventos";
              }
            }
            document.querySelector('#toolbox #verTodos')
                .href = `${APPURL}/#/${urlTodos}?identifier=${Util.getIdentifier()}`;
            // if(data.length > 0){
            $(`.event-box .selected`).toggleClass('selected');
            if(className != null){
              $(`.event-box .${className}`).toggleClass('selected');
            }
            lastSelected = type;
            // }
            if(type == "publicacoes"){
              data = data.rows;
            }
            var countRows = type == "publicacoes" ? (data.length > 12 ? 12 : data.length) : data.length;
            for(var i=0;i<countRows;i++){
              var check = false;
              if(type == "eventoSeminario"){
                if(data[i].tipo == "seminario" || data[i].tipo == "evento"){
                  check = true;
                }
              }
              if(type == data[i].tipo && type != "publicacoes"){
                check = true;
              }
              if (check) {
                let stringData = "";
                if(data[i].horario_inicial && data[i].horario_final){
                  stringData = `
                    <div class="my-auto" style="margin-left:5px;">\n
                      <svg class="svg-inline--fa fa-clock fa-w-16 fa-fw" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" role="img" data-icon="clock" data-prefix="fal" focusable="false" style="color: #0193a8;" width="8" height="20" aria-hidden="true">\n
                          <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z" class=""></path>\n
                      </svg>\n
                      <span>\n
                        ${data[i].horario_inicial}\n
                        às\n
                        ${data[i].horario_final}\n
                      </span>\n
                    </div>\n`;
                }
                let translatedDate = data[i].data_inicial;
                if (data[i].data_inicial !== data[i].data_final) {
                  translatedDate = ({
                      'pt': `${data[i].data_inicial} até ${data[i].data_final}`,
                      'en': `${data[i].data_inicial} to ${data[i].data_final}`,
                      'es': `${data[i].data_inicial} a ${data[i].data_final}`
                  })[getLocale()];
                }
                html += `<div class="col-11 col-xl-5 card shadow my-3 mx-auto" style="border-radius: .75rem!important">\n
                  <a class="m-1" style="text-decoration:none;" target="_blank" href="${APPURL}/#/evento/${data[i].slug}?identifier=${Util.getIdentifier()}" data-target="eventos">\n

                    <img alt="Card image cap box-image" class="pt-3 mb-1 box-image w-100"
                      src="${data[i].banner}">\n
                    <span class="card-text font-weight-bold w-100">\n
                        ${data[i].nomeEvento}\n
                    </span>\n

                    <div class="my-1 row">\n
                      <div class="my-auto" style="margin-left:5px;">\n
                        <svg aria-hidden="true" width="18" height="20" style="color: #0193a8;" focusable="false" data-prefix="far" data-icon="calendar-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">\n
                          <path fill="currentColor" d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" class=""></path>\n
                        </svg>\n
                        <span class="">\n
                          ${translatedDate}\n
                        </span>\n
                      </div>\n
                      ${stringData}
                    </div>\n

                  </a>\n
                </div>`;
              }
              if(type == "publicacoes"){
                html += `<div class="col-11 col-md-11 card shadow my-3 ml-4 mr-4" style="border-radius: .75rem!important;">\n
                    <a style="text-decoration:none;" data-target="eventos" target="_blank"
                      href="${APPURL}/#/publicacoes/detalhe/${data[i].id}?identifier=${Util.getIdentifier()}"> \n
                      <div class="m-1 text-center">\n
                        <img alt="Card image cap box-image" class="pt-3 mb-1 box-image"
                          src="${data[i].banner}" style="max-height: 300px; max-width: 100%;">\n
                      </div>\n
                      <div>
                        <span class="card-text font-weight-bold w-100">\n
                            ${data[i].tituloPublicacao}\n
                        </span>\n
                      </div>
                    </a>
                </div>`;
              }
            };
            $('[name=toolbox-calendar-no-data]:not(.d-none)').toggleClass('d-none')
            if(html.length <= 0){
              $('[name=toolbox-calendar-no-data].d-none').toggleClass('d-none')
            }
            $(".event-box .row.posts").html(html);
          },
          error: function (data) {},
        });
      } catch (e) {}
    }
  });
}

//login
jQuery(function ($) {
  $("#frm-login").submit(function (e) {
    e.preventDefault();
    var email = $("#login-email").val();
    var senha = $("#login-senha").val();
    if (!Util.validateEmail(email)) {
      alert("Por favor, Digite um e-mail válido.");
      return false;
    }
    if (senha.length < 1) {
      alert("Por favor digite uma senha");
      return false;
    }

    blockScreen();
    $.ajax({
      url: APIURL + "/login/dashboard",
      headers: {
        "identifier": Util.getIdentifier()
      },
      data: { email: email, senha: senha },
      type: "post",
      success: function (data) {
        unBlockScreen();
        $("#btn-close-nav").click();
        for (var i in data) {
          localStorage.setItem(i, data[i]);
        }
        tokenParam = "?token=" + localStorage.getItem("token");
        $("#login-email").val("");
        $("#login-senha").val("");
        $("#username").html(localStorage.getItem("nomeCompleto").split(' ')[0]);
        $("#notUserLogged").attr('style', 'display:none');
        $("#userLogged").removeAttr('style', 'display:none');
        $("#userLogged #userName").html(localStorage.getItem("nomeCompleto").split(' ')[0]);
        $(".form-top").hide();
        $("#menu-geral-nologged").hide();
        $("#menu-geral-logged").show();
        if (URLTarget != null) {
          if (URLPerms != null) {
            var role = "";
            switch (URLPerms) {
              case "export":
                role = "ROLE_EMPRESA_COMO_EXPORTAR";
                break;
              case "import":
                role = "ROLE_EMPRESA_COMO_IMPORTAR";
                break;
              default:
                role = URLPerms;
                break;
            }
            if (hasRole(role)) {
              window.location.href = URLTarget + tokenParam + "&identifier=" + Util.getIdentifier();
              return;
            }
          } else {
            if(URLTarget?.includes('?')){
              window.location.href = URLTarget + '&' + tokenParam.split('?')[1] + "&identifier=" + Util.getIdentifier();
              return;
            }
            window.location.href = URLTarget + tokenParam + "&identifier=" + Util.getIdentifier();
            return;
          }
        } else if (actionTarget) {
          switch (actionTarget) {
            case "goToServerMonkey":
              if (hasRole("ROLE_EMPRESA_AVALIACAO")) {
                window.open($("#avaliacao-valida").attr("href"), "_blank");
              } else {
                alert("Lamentamos, mas. você não tem permissão para acessar esse questionário.\nObrigado pela compreensão");
              }
              break;
            case "goToMapaROLE_EMPRESA_COMO_IMPORTAR":
              if (hasRole("ROLE_EMPRESA_COMO_IMPORTAR")) {
                window.location.href = "/de-onde-importar" + "?identifier=" + Util.getIdentifier();
              } else {
                alert("Lamentamos, mas. você não tem permissão para acessar esse mapa.\nObrigado pela compreensão");
              }
              break;
            case "goToMapaROLE_EMPRESA_COMO_EXPORTAR":
              if (hasRole("ROLE_EMPRESA_COMO_EXPORTAR")) {
                window.location.href = "/para-onde-exportar" + "?identifier=" + Util.getIdentifier();
              } else {
                alert("Lamentamos, mas. você não tem permissão para acessar esse mapa.\nObrigado pela compreensão");
              }
              break;
          }
        } else {
          goToDashboard()
        }
        if (localStorage.getItem("user_id") && window.location.href === SITEURL + "/internacionalize-agora") {
          getTrilhas("export", localStorage.getItem("user_id"));
          getTrilhas("import", localStorage.getItem("user_id"));
        }
        mostraBotaoDash();
      },
      error: function (data) {
        unBlockScreen();
        var errorMensage = "";
        if (data.responseJSON && data.responseJSON.message) {
            errorMensage = data.responseJSON.message;
        } else {
          errorMensage = "Erro desconhecido";
        }
        alert(errorMensage);

      },
    });
  });
});

//logout
function logout() {
  jQuery(function ($) {
    $.ajax({
      url: APIURL + "/login/logout" + tokenParam,
      headers: {
        "identifier": Util.getIdentifier()
      },
      type: "get",
      success: function (data) {
        localStorage.clear();
        tokenParam = "";
        $("#username").html("");
        $("#notUserLogged").removeAttr('style', 'display:none');
        $("#userLogged").attr('style', 'display:none');
        $("#menu-geral-logged").hide();
        $("#menu-geral-nologged").show();
        if (window.location.href === SITEURL + "/internacionalize-agora") {
          $(".trilha li").each(function () {
            $(this).removeClass("lido");
          });
        }
      },
    });
  });
}

//E-mail para recuperar senha
jQuery(function ($) {
  $("#frm-esqueci-senha #cnpj-email").on('keyup', function() {
    $('#frm-esqueci-senha #esqueci-senha-email').html('<option value="0">Selecione</option>');
    $('#campo-email').hide();
    var cnpjEmail = $('#frm-esqueci-senha #cnpj-email').val().replace(/\D/g,'');
    if(Util.validarCNPJ(cnpjEmail)){
      try {
        $.ajax({
          url: APIURL + `/users/company_cnpj/${cnpjEmail}` ,
          headers: {
            "identifier": Util.getIdentifier()
          },
          processData: true,
          dataType: "json",
          type: 'get',
          success: function (data) {
            $('#frm-esqueci-senha #esqueci-senha-email').html('<option value="0">Selecione</option>');
            if (data.objectResult.length) {
              $('#campo-email').show();
              data.objectResult.forEach((data) => {
                $('#frm-esqueci-senha #esqueci-senha-email')
                  .append(`<option value="${data.email}">${criptografaEmail(data.email)}</option>`);
              });
            }
          },
          error: function (data) {
            alert(data.responseJSON.mensage);
          }
        });
      } catch (e) {
        alert(e);
      }
    }
  });
  $('#frm-esqueci-senha').submit(function (e) {
    e.preventDefault();

    var cnpj_email = $("#frm-esqueci-senha #cnpj-email").val();
    var emailDeEnvio = $('#frm-esqueci-senha #esqueci-senha-email');

    if (Util.validateEmail(cnpj_email) && emailDeEnvio.val() == false) {
      if (cnpj_email.split("@")[1] === 'fiesc.com.br') {
        alert("Para usuários FIESC sua senha deve ser renovada a partir dos canais internos de renovação de senha");
        return false;
      }
      else{
        try {
          $.ajax({
            url: APIURL + "/esqueci/senha",
            headers: {
              "identifier": Util.getIdentifier()
            },
            data: {
              email: cnpj_email
            },
            processData: true,
            dataType: "json",
            type: 'post',
            success: function (data) {
              $('.form-top').hide();
              $('#codigo-recuperacao-senha').show();
            },
            error: function (data) {
              alert(data.responseJSON.mensage);
            }
          });
        } catch (e) {
          alert(e);
        }
      }
    }
    else if(Util.validarCNPJ(cnpj_email.replace(/\D/g,'')) && emailDeEnvio.val()){
		try {
			$.ajax({
			  url: APIURL + "/esqueci/senha",
        headers: {
          "identifier": Util.getIdentifier()
        },
			  data: {
				email: emailDeEnvio.val()
			  },
			  processData: true,
			  dataType: "json",
			  type: 'post',
			  success: function (data) {
          $('.form-top').hide();
          $('#codigo-recuperacao-senha').show();
			  },
			  error: function (data) {
				  alert(data.responseJSON.mensage);
			  }
			});
		  } catch (e) {
			  alert(e);
		  }
	}else{
		alert("E-mail ou CNPJ informado inválidos.");
	}
  });
});

function criptografaEmail(email){
	var partes = email.split('@');
	var nick = partes[0].slice(0,3);
	var provedor = partes[1].slice(0,3);
	return nick+'***@'+provedor+'***';
}

//Código de recuperação
jQuery(function ($) {
  $('#frm-codigo-senha').submit(function (e) {
    e.preventDefault();
    var codigo = $('#codigo-recuperacao-email').val();
    if (codigo === '' || codigo === null) {
      alert('Por favor, preencha um código');
    } else {
      $.ajax({
        url: APIURL + "/esqueci/codigo",
        headers: {
          "identifier": Util.getIdentifier()
        },
        data: {
          codigo: codigo
        },
        type: 'post',
        success: function (data) {
          $('#tipo-redefinicao').val('recuperacao');
          $('.form-top').hide();
          $('#esqueci-senha-redefinir').show();
          $('#novasenha-id').val(data);
        },
        error: function (data) {
          alert("Código fornecido não é válido");
        }
      });
    }
  })
});

//Senha Atual de trocar senha
jQuery(function ($) {
  $('#frm-atual-senha').submit(function (e) {
    e.preventDefault();

    var senha = $('#senha-atual-email').val();
    if (senha == '') {
      alert('Preencha a sua senha atual');
      return false;
    }
    $.ajax({
      url: APIURL + "/senha/atual",
      headers: {
        "identifier": Util.getIdentifier(),
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      },
      data: {
        email: localStorage.getItem('email'),
        senha: senha
      },
      type: 'post',
      success: function (data) {
        if (data) {
          $('#tipo-redefinicao').val('redefinicao');
          $('.form-top').hide();
          $('#esqueci-senha-redefinir').show();
          $('#novasenha-id').val(localStorage.getItem('user_id'));
        } else {
          alert("Senha atual inválida");
        }

      },
      error: function (data) {
        alert("Senha atual inválida");
      }
    });
  })
});

//nova senha
jQuery(function ($) {
  $('#frm-nova-senha').submit(function (e) {
    e.preventDefault();
    var id = $('#novasenha-id').val();
    var novaSenha = $('#nova-senha').val();
    var novaSenhaConfirma = $('#nova-senha-confirma').val();
    var senhaAtual = $('#senha-atual-email').val();
    var codigo = $('#codigo-recuperacao-email').val();

    if (!verificaForcaSenha($('#nova-senha'))) {
      return false;
    }

    if (novaSenha != novaSenhaConfirma) {
      alert("Senhas não coencidem.");
      return false;
    }

    let data = {
      senhaAtual: senhaAtual,
      senhaNova: novaSenha
    }
    let url = APIURL + "/";
    if($('#tipo-redefinicao').val() === "recuperacao"){
      url += "esqueci/";
      data = {
        novaSenha: novaSenha,
        codigo: codigo
      }
    }
    url += "novasenha/" + id;

    $.ajax({
      url: url,
      headers: {
        "identifier": Util.getIdentifier()
      },
      data: data,
      type: 'post',
      success: function (data) {
        if($('#tipo-redefinicao').val() === "recuperacao"){
          localStorage.clear();
          tokenParam = '';
          $('.form-top').hide();
          $("#login-email").val(data.email);
          $('#logando').show();
          $('#username').html('');
          $('#menu-geral-logged').hide();
          $('#menu-geral-nologged').show();
          $('#esqueci-senha-redefinir').hide();
        }
        if($('#tipo-redefinicao').val() === "redefinicao"){
          $("#btn-close-nav").click();
        }
        $('#nova-senha').val(null);
        $('#nova-senha-confirma').val(null);
        $('#senha-atual-email').val(null);
        $('#codigo-recuperacao-email').val(null);
      },
      error: function (data) {
        alert("Falha ao renovar a senha.");
      }
    });

  })
});

//abre menu do mapa do site
jQuery(function ($) {
  $(document).ready(function () {
    $("#bt-3").click(function () {

      $("#div-3").toggle("slow");
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#div-3").offset().top
      }, 2000);
    });
  })
});

//Internacionalize Agora

function getTrilhas(type, user_id) {
  var classSearch = (type === 'export') ? 'trilha-exportar' : 'trilha-importar';
  jQuery(function ($) {
    var urlSend = getApiUrl();
    if (user_id) {
      urlSend += '/passos/' + user_id + '/' + type;
    } else {
      urlSend += '/passos?type=' + type;
    }
    $.ajax({
      url: urlSend,
      headers: {
        "identifier": Util.getIdentifier()
      },
      type: 'get',
      success: function (data) {
        var i = 0;
        $('.' + classSearch + ' li').each(function () {
          if (data[i].id) {
            $(this).attr('data-id', data[i].slug);
            $(this).attr('data-tipo', type);
            if (data[i].lido) {
              $(this).addClass('lido');
            }
            $(this).children('div.passo-title').html(data[i].title);
            $(this).removeClass('disable-colmeia');
            i++;
          }
        });
      }
    });
  })
}

if (localStorage.getItem('user_id') != null && window.location.pathname === '/internacionalize-agora') {
  getTrilhas('export', localStorage.getItem('user_id'));
  getTrilhas('import', localStorage.getItem('user_id'));
} else if (localStorage.getItem('user_id') == null && window.location.pathname === '/internacionalize-agora') {
  getTrilhas('export', false);
  getTrilhas('import', false);
} else {
  getTrilhas('export', false);
  getTrilhas('import', false);
}

function validaPermissãoTrilhas(tipo) {
  var role = (tipo === 'export') ? 'ROLE_EMPRESA_COMO_EXPORTAR' : 'ROLE_EMPRESA_COMO_IMPORTAR';
  if (hasRole(role) || hasRole('ROLE_USER_FIESC') || hasRole('ROLE_USER_FISICO')) {
    return true;
  }
  return false;
}

jQuery(function ($) {
  $(document).on('click', '.trilha li', function () {

    if (localStorage.getItem('token') && localStorage.getItem('token') != null) {
      if ($(this).attr('data-id') && validaPermissãoTrilhas($(this).attr('data-tipo'))) {
        redirectDash((($(this).attr('data-tipo') === 'export') ? 'como-exportar' : 'como-importar') + '/' + $(this).attr('data-id'));
      } else {
        alert("Você não tem permissão para acessar a trilha, \n favor entrar em contato com cin@fiesc.com.br. \n Obrigado pela compreensão.");
        return;
      }
    } else {
      URLTarget = APPURL + '/#/' + (($(this).attr('data-tipo') === 'export') ? 'como-exportar' : 'como-importar') + '/' + $(this).attr('data-id');
      URLPerms = $(this).attr('data-tipo');
      $('.form-top').hide();
      $('#logando').show();
      $("#btn-open-nav").click();
    }

  });

  $(document).on('click', '.mobile-btn', function () {
    if (localStorage.getItem('token')) {
      var trilha_id = ($(this).attr('data-action') === 'export') ? $('.trilha-exportar > ul > li:first').attr('data-id') : $('.trilha-importar > ul > li:nth-child(1)').attr('data-id');
      var trilha_type = ($(this).attr('data-action') === 'export') ? 'como-exportar' : 'como-importar';
      if (trilha_id != undefined) {
        redirectDash(trilha_type + '/' + trilha_id);
      }
    } else {
      URLTarget = APPURL + '/#/' + (($(this).attr('data-tipo') === 'export') ? 'como-exportar' : 'como-importar') + '/' + $(this).attr('data-id') + tokenParam;
      $('.form-top').hide();
      $('#logando').show();
      $("#btn-open-nav").click();
    }
  });


  $(document).on('click', '.footer-internacionalize a', function (e) {
    e.preventDefault();
    var destination = $(this).attr('data-target');
    var urlTargetDestination = '';
    switch (destination) {
      case 'capacitacao':
        urlTargetDestination = 'eventos/capacitacoes';
        break;
      case 'eventos':
        urlTargetDestination = 'eventos/' + destination;
        break;
      case 'publicaoes':
        urlTargetDestination = 'publicacoes';
        break;
    }
    redirectDash(urlTargetDestination);
  })
});


function hasLoggedUser() {
  return +localStorage.getItem('user_id') > 0;
}

//Eventos, Missões, Seminários, Capacitação e publicações

if (window.location.href === SITEURL + '/internacionalize-agora') {
  jQuery(function ($) {
    $.ajax({
      url: APIURL + '/#/eventos/internacionalize/evento',
      headers: {
        "identifier": Util.getIdentifier()
      },
      type: 'get',
      success: function (data) {
        if (data.banner != null) {
          $("#box-evento img.box-image").attr('src', APIUPLOADSURL + '/' + data.banner);
        }
      }
    });
    $.ajax({
      url: APIURL + '/#/eventos/internacionalize/capacitacao' + tokenParam,
      headers: {
        "identifier": Util.getIdentifier()
      },
      type: 'get',
      success: function (data) {
        if (data.banner != null) {
          $("#box-capacitacao img.box-image").attr('src', APIUPLOADSURL + '/' + data.banner);
        }
      }
    });

  });
}
jQuery(function ($) {
  $('#termos-uso').change(function () {
    if ($(this).prop('checked')) {
      $('#cadastroEmpresa').attr('disabled', false);
      $('#regras-termo-de-uso').removeClass('regras-termo-de-uso');
    } else {
      $('#cadastroEmpresa').attr('disabled', true);
      $('#regras-termo-de-uso').addClass('regras-termo-de-uso');
    }
  });
});

jQuery(function ($) {
  $(' #termos-uso2').change(function () {
    if ($(this).prop('checked')) {
      $('#cadastroFisica').attr('disabled', false);
      $('#regras-termo-de-uso2').removeClass('regras-termo-de-uso');
    } else {
      $('#cadastroFisica').attr('disabled', true);
      $('#regras-termo-de-uso2').addClass('regras-termo-de-uso');
    }
  });
});

//mudando nome dos botoes enviar
jQuery(function ($) {
  $('#edit-submit, #edit-submit--2').val("Enviar");
  //zerando input do selecione assunto
  $('#edit-field-selecione-o-assunto-').val("");
  //mascara telefone contato
  $("#edit-field-telefone-0-value--2, #edit-field-telefone-0-value").attr("onkeydown", "Util.mascara('(##) #####-####',this,event,true)");
  //mascara cnpj orcamento
  $("#edit-field-cnpj-0-value").attr("onkeydown", "Util.mascara('AA.AAA.AAA/AAAA-##',this,event,true)");
  //
  $("#edit-field-selecione-o-assunto-").val('');
  //
  $("#edit-field-selecione-o-assunto-").removeAttr("multiple", "multiple");
  //

});

function hasRole(role) {
  var permitido = false;
  if (localStorage.getItem('roles') !== false && localStorage.getItem('roles') !== null) {
    var roles = localStorage.getItem('roles').split(',');
    for (var i in roles) {
      if (roles[i] === role) {
        permitido = true;
      }
    }
    return permitido;
  }
}

//Confirma permissão avaliação de maturidade questionário
if (window.location.href === SITEURL + '/avaliacao-de-Maturidade') {
  jQuery(function ($) {
    $('.jumbotron-descubra-seu-nivel a').click(function (e) {
      if (localStorage.getItem('token') === null || localStorage.getItem('token').length < 0) {
        actionTarget = 'goToServerMonkey';
        $('.form-top').hide();
        $('#logando').show();
        $("#btn-open-nav").click();
        return false;
      } else {
        if (hasRole('ROLE_EMPRESA_AVALIACAO')) {
          return true;
        } else {
          alert("Lamentamos, mas. você não tem permissão para acessar esse questionário.\nObrigado pela compreensão");
          return false;
        }
      }
    })
  });
}

//Confirma permissão mapas
// if (window.location.href === SITEURL + '/internacionalize-agora') {
//   jQuery(function ($) {
//     $('.target-para').click(function (e) {
//       var role = ($(this).attr('attr') === '/de-onde-importar') ? 'ROLE_EMPRESA_COMO_IMPORTAR' : 'ROLE_EMPRESA_COMO_EXPORTAR';
//       if (localStorage.getItem('token') === null || localStorage.getItem('token').length < 0) {
//         actionTarget = 'goToMapa' + role;
//         $('.form-top').hide();
//         $('#logando').show();
//         $("#btn-open-nav").click();
//         return false;
//       } else {
//         if (hasRole(role)) {
//           return true;
//         } else {
//           alert("Lamentamos, mas. você não tem permissão para acessar esse mapa.\nObrigado pela compreensão");
//           return false;
//         }
//       }
//
//     })
//   });
// }

jQuery(function ($) {
  window.onmousedown = function (e) {
    var el = e.target;
    if (el.tagName.toLowerCase() == 'option' && el.parentNode.hasAttribute('multiple')) {
      e.preventDefault();

      // toggle selection
      if (el.hasAttribute('selected')) el.removeAttribute('selected');
      else el.setAttribute('selected', '');

      // corrigir comportamento inconsistente
      var select = el.parentNode.cloneNode(true);
      el.parentNode.parentNode.replaceChild(select, el.parentNode);
    }
  }
});

function mostraBotaoDash() {
  jQuery(function ($) {
    if (possuiPermissaoDashFiesc() || possuiPermissaoDashEmpresa()) {
      $('#menu-dash').show();
    }
  });
}

function possuiPermissaoDashFiesc() {
  return hasRole('ROLE_USER_FIESC') && hasRole('ROLE_DASHBOARD_EMPRESA');
}

function possuiPermissaoDashEmpresa() {
  return (hasRole('ROLE_USER_EMPRESA') && hasRole('ROLE_EMPRESA')) || hasRole('ROLE_USER_COMPRADOR');
}

function goToNoticias() {
  redirectDash('noticias');
}

function goToDashboard() {
  jQuery(function ($) {
    if (possuiPermissaoDashFiesc()) {
      redirectDash('dashboard/empresas');
    } else if (possuiPermissaoDashEmpresa()) {
      const companyId = localStorage.getItem('company_id') ? localStorage.getItem('company_id') : localStorage.getItem('buyerCompanyId');
      redirectDash(`dashboard/empresa/${companyId}`);
    }
  });
}

function redirectDash(pathName, additionalParams = []) {
  setTimeout(function () {
    let queryParams = `?identifier=${Util.getIdentifier()}`;
    if (localStorage.getItem("token")) {
      queryParams += `&token=${localStorage.getItem("token")}`
    }
    additionalParams.forEach(param => {
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(param[key])}`;
        }
      }
    });
    const locale = this.getLocale();
    const location = locale === 'pt' ? '' : `/${locale}`;

    window.location.href = `${APPURL}${location}/#/${pathName}${queryParams}`;
  }, 500);
}

function clearQueryParams() {
  const url = window.location.protocol + '//' + window.location.host + window.location.pathname;
  window.history.replaceState({ path: url }, '', url);
}
